import React from "react";
import { House } from "lucide-react";

/**
 * Calm, on-brand empty state. NEVER an error tone.
 */
export default function EmptyState({
  title = "Nothing matches your filters.",
  body = "Try widening the typology or lot width.",
  actionLabel,
  onAction,
}) {
  return (
    <div
      className="wn-card flex flex-col items-center text-center"
      style={{
        padding: "56px 32px",
        gap: 18,
        borderColor: "#D9D8E4",
      }}
      data-testid="empty-state"
    >
      <House size={56} strokeWidth={1.2} color="#9AA0C0" aria-hidden />
      <div>
        <div
          style={{
            fontFamily: '"Fraunces", Georgia, serif',
            fontWeight: 600,
            fontSize: 22,
            color: "#1B1F4B",
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: "#6C6B85",
            fontSize: 14,
            marginTop: 8,
            maxWidth: 380,
            lineHeight: 1.55,
          }}
        >
          {body}
        </div>
      </div>
      {actionLabel && (
        <button
          className="wn-btn wn-btn-tertiary"
          onClick={onAction}
          data-testid="empty-action-btn"
          style={{ color: "#1B1F4B" }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
